import { useFetchMissingAcls } from '../../../hooks/use_fetch_missing_acls';
import { useAppSelector } from '../../../store/react_redux_typed';
import { selectUserRoles } from '../../../utils/get_user_roles';

export const useFetchMissingUploadStorageAcls = (storageIds: string[]) => {
  const userRoles = useAppSelector(selectUserRoles);
  // If the user can upload legacy, we don't need to fetch any ACLs
  useFetchMissingAcls(
    'storages',
    userRoles.webCanUploadLegacy ? [] : storageIds,
  );
};
